let currentProposalRecords;
let currentCustomerId;
let currentTrackingCode;

let proposalPagination = {
  Criados: {
    page: 1,
    totalPages: 1,
    totalResults: 0,
  },
  Aprovado: {
    page: 1,
    totalPages: 1,
    totalResults: 0,
  },
  Fechado: {
    page: 1,
    totalPages: 1,
    totalResults: 0,
  },
};

async function getProposalData(
  page = 1,
  status = "Aprovado",
  filterBy = "",
  filter = "",
  sortDirection = "asc"
) {
  let tabName = '';

  try {
    switch (status) {
      case 'Aprovado':
        tabName = 'abertos';
        break;
      case 'Fechado':
        tabName = 'finalizados';
        break;
    }

    proposalPagination[status].page = page;

    const token = await login();
    const cnpjR = getCnpjR();

    if (!cnpjR) {
      console.error(
        "[getProposalData] Erro: Não foi possível obter os dados da empresa"
      );
      throw "Não foi possível obter os dados da empresa";
    }

    const params = new URLSearchParams();
    params.append("customerId", customerId);
    params.append("limit", itemsPerPage);
    params.append("offset", (page - 1) * itemsPerPage);
    params.append("status", status);
    if (filterBy) params.append("filterBy", filterBy);
    if (filter) params.append("filter", filter);
    // if (sortDirection) {
    //   params.append("property", "validityPeriod");
    //   params.append("sort", sortDirection);
    // }

    const url = `${baseUrl}/shopify-order-connector/v1/shopify-order-connector/proposals?${params}`;
    const response = await fetch(url, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    });

    if (!response.ok) {
      const errorDetails = await response.text();
      console.error(
        `[getProposalData] Erro na resposta: Status ${response.status}, Detalhes: ${errorDetails}`
      );
      throw response.status;
    }

    const data = await response.json();

    const totalPages = Math.ceil(data.totalResults / itemsPerPage);
    proposalPagination[status].totalResults = data.totalResults;
    proposalPagination[status].totalPages = totalPages;

    await renderProposalData(data.items, document.querySelector(`#tab-${tabName}-content`), tabName);

    renderProposalPagination(`#pagination-container-${tabName}`, status);

    currentCustomerId = customerId;
    return data;
  } catch (error) {
    console.error(`[getProposalData] Erro capturado: ${error}`);
    throw new Error(`Erro ao buscar orçamentos: ${error}`);
  } finally {
    removeMyAccountSpinner(document.querySelector(`#tab-${tabName}`));
  }
}

async function getDraftOrders(
  page = 1,
  status = "Criados",
  filterBy = "",
  filter = "",
  sortDirection = "asc"
) {
  try {
    proposalPagination[status].page = page;

    const token = await login();
    const cnpjR = getCnpjR();

    if (!cnpjR) {
      console.error(
        "[getDraftOrders] Erro: Não foi possível obter os dados da empresa"
      );
      throw "Não foi possível obter os dados da empresa";
    }

    const params = new URLSearchParams();
    params.append("customerId", customerId);
    params.append("limit", itemsPerPage);
    params.append("offset", (page - 1) * itemsPerPage);
    if (filterBy) params.append("filterBy", filterBy);
    if (filter) params.append("filter", filter);
    // if (sortDirection) {
    //   params.append("property", "validityPeriod");
    //   params.append("sort", sortDirection);
    // }
    params.append("height", 100);
    params.append("width", 100);

    const url = `${baseUrl}/shopify-order-connector/v1/shopify-order-connector/draft-order/organization?${params}`;
    const response = await fetch(url, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    });

    if (!response.ok) {
      const errorDetails = await response.text();
      console.error(
        `[getDraftOrders] Erro na resposta: Status ${response.status}, Detalhes: ${errorDetails}`
      );
      throw response.status;
    }

    const data = await response.json();

    const totalPages = Math.ceil(data.total / itemsPerPage);
    proposalPagination[status].totalResults = data.total;
    proposalPagination[status].totalPages = totalPages;

    switch (status) {
      case "Criados":
        await renderProposalCreated(data.result ?? [], document.querySelector("#tab-criados-content"), "criados");

        renderProposalPagination("#pagination-container-criados", "Criados");

        break;
    }
    currentCustomerId = customerId;
    return data;
  } catch (error) {
    console.error(`[getDraftOrders] Erro capturado: ${error}`);
    throw new Error(`Erro ao buscar orçamentos: ${error}`);
  }
}

function renderProposalPagination(container, status = "Aprovado") {
  const paginationContainer = document.querySelector(container);

  if (!paginationContainer) {
    console.error("[renderProposalPagination] Container de paginação não encontrado.");
    return;
  }
  const paginationGroup = proposalPagination[status];

  if (paginationGroup.totalResults === 0) {
    paginationContainer.style.display = "none";
    return;
  };

  paginationContainer.innerHTML = "";
  paginationContainer.setAttribute('status', status);

  const prevButton = document.createElement("button");
  prevButton.textContent = "Anterior";
  prevButton.disabled = paginationGroup.page === 1;

  prevButton.addEventListener("click", () => {
    if (paginationGroup.page !== 1) {
      const newPage = paginationGroup.page - 1;


      if (['Criados'].includes(status)) getDraftOrders(newPage, status);
      else getProposalData(newPage, status);
    }
  });
  paginationContainer.appendChild(prevButton);

  const maxVisibleButtons = 5;
  let startPage, endPage;

  if (paginationGroup.totalPages <= maxVisibleButtons) {
    startPage = 1;
    endPage = paginationGroup.totalPages;
  } else {
    const maxButtonsBeforeCurrent = Math.floor(maxVisibleButtons / 2);
    const maxButtonsAfterCurrent = Math.ceil(maxVisibleButtons / 2) - 1;

    if (paginationGroup.page <= maxButtonsBeforeCurrent) {
      startPage = 1;
      endPage = maxVisibleButtons;
    } else if (paginationGroup.page + maxButtonsAfterCurrent >= paginationGroup.totalPages) {
      startPage = paginationGroup.totalPages - maxVisibleButtons + 1;
      endPage = paginationGroup.totalPages;
    } else {
      startPage = paginationGroup.page - maxButtonsBeforeCurrent;
      endPage = paginationGroup.page + maxButtonsAfterCurrent;
    }
  }

  for (let i = startPage; i <= endPage; i++) {
    const pageButton = document.createElement("button");
    pageButton.textContent = i;

    if (i === paginationGroup.page) {
      pageButton.classList.add("active");
    }

    pageButton.addEventListener("click", () => {
      if (['Criados'].includes(status)) getDraftOrders(i, status);
      else getProposalData(i, status);
    });

    paginationContainer.appendChild(pageButton);
  }

  const nextButton = document.createElement("button");
  nextButton.textContent = "Próximo";
  nextButton.disabled = paginationGroup.page === paginationGroup.totalPages;

  nextButton.addEventListener("click", () => {
    if (paginationGroup.page < paginationGroup.totalPages) {
      const newPage = paginationGroup.page + 1;
      if (['Criados'].includes(status)) getDraftOrders(newPage, status);
      else getProposalData(newPage, status);
    }
  });
  paginationContainer.appendChild(nextButton);
}

async function initProposalPage() {
  currentPage = 1;
  await getProposalData(1);

  if (!customerId) {
    console.error("[initProposalPage] Erro: customerId não está disponível.");
    return;
  }

  await getProposalData(1);
}

document.addEventListener("DOMContentLoaded", function () {
  initProposalPage();
});

async function loadProposalData() {
  try {
    showMyAccountSpinner(document.querySelector("#tab-criados"));
    showMyAccountSpinner(document.querySelector("#tab-abertos"));
    showMyAccountSpinner(document.querySelector("#tab-finalizados"));

    const createdProposalData = await fetchWithCache("createdProposals", () => getDraftOrders(1, "Criados"));

    const approvedProposalData = await fetchWithCache("approvedProposals", () => getProposalData(1, "Aprovado"));

    const closedProposalData = await fetchWithCache("closedProposals", () => getProposalData(1, "Fechado"));

    renderProposalData(
      approvedProposalData.items ?? [],
      document.querySelector("#tab-abertos-content"),
      "abertos"
    );
    renderProposalPagination("#pagination-container-abertos", "Aprovado");

    renderProposalData(
      closedProposalData.items ?? [],
      document.querySelector("#tab-finalizados-content"),
      "finalizados"
    );
    renderProposalPagination("#pagination-container-finalizados", "Fechado");

    renderProposalCreated(
      createdProposalData.result ?? [],
      document.querySelector("#tab-criados-content"),
      "criados"
    );
    renderProposalPagination("#pagination-container-criados", "Criados");

  } catch (error) {
    console.error("❌ Erro ao carregar os dados:", error);
    handleNoRecordsMessage("abertos");
    handleNoRecordsMessage("finalizados");
    handleNoRecordsMessage("criados");
  } finally {
    removeMyAccountSpinner(document.querySelector("#tab-criados"));
    removeMyAccountSpinner(document.querySelector("#tab-abertos"));
    removeMyAccountSpinner(document.querySelector("#tab-finalizados"));
  }
}
function renderProposalCreated(proposalRecords, container, tabName) {
  if (!container) {
    console.error(`❌ #tab-${tabName} não encontrado no DOM.`);
    return;
  }
  container.innerHTML = "";

  const records = Array.isArray(proposalRecords)
    ? proposalRecords
    : proposalRecords?.result ?? [];

  if (!records || records.length === 0) {
    handleNoRecordsMessage(tabName);
    return;
  }

  records.forEach((record) => {
    const payload = record?.payload ?? {};

    const id = payload.id ?? "—";

    const creationDateRaw = payload.created_at ?? null;

    const validityRaw = payload.validityPeriod ?? creationDateRaw;

    const aprovDate = creationDateRaw ? new Date(creationDateRaw) : new Date();
    const emitidaDate = validityRaw ? new Date(validityRaw) : aprovDate;

    const block = document.createElement("div");
    const blockInfo = document.createElement("div");

    block.className = "proposal-block";
    block.setAttribute("data-page", "/pages/detalhes-de-orcamentos");

    blockInfo.classList.add("block-info");

    const proposalMobileDate = document.createElement("p");
    proposalMobileDate.classList.add("mobile-date");
    proposalMobileDate.textContent = aprovDate.toLocaleDateString("pt-BR", {
      day: "2-digit",
      month: "2-digit",
      year: "2-digit",
      timeZone: "UTC",
    });

    const proposalName = document.createElement("p");
    proposalName.className = "balance-value proposal-number";
    proposalName.textContent = id;

    const proposalAproveDate = document.createElement("p");
    proposalAproveDate.className = "credit-name date";
    proposalAproveDate.textContent = aprovDate.toLocaleDateString("pt-BR", {
      day: "2-digit",
      month: "2-digit",
      year: "2-digit",
      timeZone: "UTC",
    });

    const proposalValidaDate = document.createElement("p");
    proposalValidaDate.className = "credit-name date validity-date";
    proposalValidaDate.textContent = emitidaDate.toLocaleDateString("pt-BR", {
      day: "2-digit",
      month: "2-digit",
      year: "2-digit",
      timeZone: "UTC",
    });

    const proposalPaymentType = document.createElement("p");
    proposalPaymentType.className = "credit-name payment-condition";
    proposalPaymentType.textContent = record.payload.metafields.pix
    ? "PIX"
    : record.payload.metafields.rewards
      ? "REWARDS"
      : record.payload.metafields.creditCard
        ? "CARTÃO DE CRÉDITO"
        : (record.payload.metafields.friendlyName ?? "—");

    const subtotal = payload.subtotal_price ?? null;

    let proposalTotal = null;
    if (subtotal !== null) {
      proposalTotal = document.createElement("p");
      proposalTotal.className = "balance-value proposal-value";
      proposalTotal.textContent = `R$ ${parseFloat(subtotal).toLocaleString(
        "pt-BR",
        {
          minimumFractionDigits: 2,
          maximumFractionDigits: 2,
        }
      )}`;
    }

    const linkElement = document.createElement("a");
    const svgSrc = document.getElementById("arrow-right");
    if (svgSrc) {
      const svgIcon = svgSrc.cloneNode(true);
      svgIcon.style.display = "inline";
      linkElement.appendChild(svgIcon);
    }
    linkElement.className = "proposal-link";

    blockInfo.appendChild(proposalMobileDate);
    blockInfo.appendChild(proposalName);
    blockInfo.appendChild(proposalValidaDate);
    blockInfo.appendChild(proposalPaymentType);
    blockInfo.appendChild(proposalTotal);

    block.appendChild(blockInfo);
    block.appendChild(linkElement);
    container.appendChild(block);

    block.addEventListener("click", async (event) => {
      if (block.classList.contains("logout-link")) return;

      event.preventDefault();
      const pageUrl = block.getAttribute("data-page");
      setActiveLink(block);

      try {
        const response = await fetch(pageUrl);
        if (!response.ok) throw new Error("Erro ao carregar a página.");

        const html = await response.text();
        const parser = new DOMParser();
        const doc = parser.parseFromString(html, "text/html");
        const content = doc.querySelector("#page-account");

        const pageContent = document.getElementById("page-content");
        pageContent.innerHTML = content
          ? content.innerHTML
          : "<p>Conteúdo não encontrado.</p>";

        await loadDetailProposalCreated(record);

        document.querySelectorAll(".sidebar .menu a").forEach((link) => {
          if (link.getAttribute("data-page") === "/pages/orcamentos") {
            link.classList.add("active");
          }
        });
      } catch (error) {
        console.error(error);
        document.getElementById("page-content").innerHTML =
          "<p>Erro ao carregar o conteúdo.</p>";
      }
    });
  });

  if (records.length > 0) {
    const proposalHeader = document.querySelector("#proposal-header-" + tabName);
    proposalHeader?.classList.add("active");
  }
}




function renderProposalData(proposalRecords, container, tabName) {
  if (!container) {
    console.error(`❌ #tab-${tabName} não encontrado no DOM.`);
    return;
  }

  container.innerHTML = "";

  if (!proposalRecords || proposalRecords.length === 0) {
    handleNoRecordsMessage(tabName);
    return;
  }

  // proposalRecords.items.forEach((record) => {
  proposalRecords.forEach((record) => {
    const block = document.createElement("div");
    const blockInfo = document.createElement("div");

    block.className = "proposal-block";
    block.setAttribute("data-page", "/pages/detalhes-de-orcamentos");

    blockInfo.classList.add("block-info");

    const aprovDate = new Date(record.creationDate);
    const emitidaDate = new Date(record.validityPeriod);

    const proposalMobileDate = document.createElement("p");
    proposalMobileDate.classList.add("mobile-date");
    proposalMobileDate.textContent = aprovDate.toLocaleDateString("pt-BR", {
      day: "2-digit",
      month: "2-digit",
      year: "2-digit",
      timeZone: "UTC",
    });

    const proposalName = document.createElement("p");
    proposalName.className = "balance-value proposal-number";
    proposalName.textContent = record.id;

    const proposalAproveDate = document.createElement("p");
    proposalAproveDate.className = "credit-name date";
    proposalAproveDate.textContent = aprovDate.toLocaleDateString("pt-BR", {
      day: "2-digit",
      month: "2-digit",
      year: "2-digit",
      timeZone: "UTC",
    });

    const proposalValidaDate = document.createElement("p");
    proposalValidaDate.className = "credit-name date validity-date";
    proposalValidaDate.textContent = emitidaDate.toLocaleDateString("pt-BR", {
      day: "2-digit",
      month: "2-digit",
      year: "2-digit",
      timeZone: "UTC",
    });

    // proposalNumber
    // const poNumber = document.createElement("p");
    // poNumber.className = "credit-name payment-condition";
    // poNumber.textContent = record.poNumber;

    const proposalPaymentType = document.createElement("p");
    proposalPaymentType.className = "credit-name payment-condition";
    proposalPaymentType.textContent = record.payment.paymentConditionName;

    const proposalTotal = document.createElement("p");
    proposalTotal.className = "balance-value proposal-value";
    proposalTotal.textContent = `R$ ${parseFloat(
      record.price.grossTotalST
    ).toLocaleString("pt-BR", {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    })}`;

    const linkElement = document.createElement("a");
    const svgIcon = document.getElementById("arrow-right").cloneNode(true);
    svgIcon.style.display = "inline";
    linkElement.appendChild(svgIcon);
    linkElement.className = "proposal-link";

    blockInfo.appendChild(proposalMobileDate);
    blockInfo.appendChild(proposalName);
    blockInfo.appendChild(proposalValidaDate);
    // blockInfo.appendChild(poNumber);
    blockInfo.appendChild(proposalPaymentType);
    blockInfo.appendChild(proposalTotal);

    block.appendChild(blockInfo);
    block.appendChild(linkElement);

    container.appendChild(block);

    block.addEventListener("click", async (event) => {
      if (block.classList.contains("logout-link")) return;

      event.preventDefault();
      const pageUrl = block.getAttribute("data-page");
      setActiveLink(block);

      try {
        const response = await fetch(pageUrl);
        if (!response.ok) throw new Error("Erro ao carregar a página.");

        const html = await response.text();
        const parser = new DOMParser();
        const doc = parser.parseFromString(html, "text/html");
        const content = doc.querySelector("#page-account");

        const pageContent = document.getElementById("page-content");
        pageContent.innerHTML = content
          ? content.innerHTML
          : "<p>Conteúdo não encontrado.</p>";

        await loadDetailProposal(record);

        document.querySelectorAll(".sidebar .menu a").forEach((link) => {
          if (link.getAttribute("data-page") === "/pages/orcamentos") {
            link.classList.add("active");
          }
        });
      } catch (error) {
        console.error(error);
        document.getElementById("page-content").innerHTML =
          "<p>Erro ao carregar o conteúdo.</p>";
      }
    });
  });

  if (proposalRecords.length > 0) {
    const proposalHeader = document.querySelector(
      "#proposal-header-" + tabName
    );
    proposalHeader.classList.add("active");
  }
}

async function loadDetailProposal(proposalData) {
  try {
    if (!proposalData) {
      console.error(
        "❌ Erro: proposalData não está definido. Verifique a importação."
      );
      return;
    }

    const proposalBlocksContainer = await waitForElement(
      ".detail-proposal",
      1000
    );
    if (proposalBlocksContainer) {
      if (typeof renderDetailProposal === "function") {
        renderDetailProposal(proposalData);
      } else {
        console.error(
          "❌ Erro: renderDetailProposal não está definido. Verifique a importação."
        );
      }
    } else {
      console.error("❌ Erro: .detail-proposal não encontrado.");
    }
  } catch (error) {
    console.error("❌ Erro ao carregar os dados:", error);
  } finally {
    //removeSpinner();
  }
}

async function loadDetailProposalCreated(proposalData) {
  try {
    if (!proposalData) {
      console.error(
        "❌ Erro: proposalData não está definido. Verifique a importação."
      );
      return;
    }

    const proposalBlocksContainer = await waitForElement(
      ".detail-proposal",
      1000
    );
    if (proposalBlocksContainer) {
      if (typeof renderDetailProposalCreated === "function") {
        renderDetailProposalCreated(proposalData);
      } else {
        console.error(
          "❌ Erro: renderDetailProposalCreated não está definido. Verifique a importação."
        );
      }
    } else {
      console.error("❌ Erro: .detail-proposal não encontrado.");
    }
  } catch (error) {
    console.error("❌ Erro ao carregar os dados:", error);
  } finally {
    //removeSpinner();
  }
}

function closeModal() {
  const modal = document.querySelector(".custom-modal");
  modal.classList.remove("active");
  modal.innerHTML = "";
}

async function renderProposalOverview(proposalRecord) {
  // Subtotal
  const subtotalValue = document.querySelector("#subtotal-value");
  subtotalValue.textContent = `R$ ${parseFloat(
    proposalRecord.price.grossTotalST
  ).toLocaleString("pt-BR", {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  })}`;

  // Total
  const totalValue = document.querySelector("#total-value");
  totalValue.textContent = `R$ ${parseFloat(
    proposalRecord.price.grossTotalST
  ).toLocaleString("pt-BR", {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  })}`;

  const stepHeadingReview = document.querySelector("#step-heading-review");
  stepHeadingReview.classList.add("active");

  const approveButton = document.querySelector("#approve-button");

  // Botões
  if (proposalRecord.status !== "Fechado") {

    if (approveButton) {
      const expireDate = new Date(proposalRecord.validityPeriod);
      const today = new Date();

      if (expireDate < today || false) {
        approveButton.textContent = "Expirado";
        approveButton.classList.add("disabled");
        approveButton.addEventListener("click", (event) => {
          event.preventDefault();
        });
      } else {
        approveButton.textContent = "Finalizar compra";
        approveButton.addEventListener("click", (event) => {
          event.preventDefault();
          approveProposal();
        });
      }
    }
  } else {
    const reviseInfoStep = document.querySelector("#summary-revise-info");
    reviseInfoStep.innerHTML = "Concluído";

    const paymentStep = document.querySelector("#summary-next-step-field");
    paymentStep.innerHTML = "Concluído";

    const stepHeadingCompleted = document.querySelector("#step-heading-completed");
    stepHeadingCompleted.classList.add("active");

    approveButton.style.display = "none";
  }
}

async function renderProposalOverviewCreated(proposalRecord) {
  const payload = proposalRecord?.payload ?? {};

  // Subtotal
  const subtotalRaw = payload.subtotal_price ?? null;

  document.querySelector("#subtotal-label").textContent = "Valor do orçamento";
  document.querySelector("#resumo-do-pedido-title").textContent = "Resumo do orçamento";

  const subtotalValue = document.querySelector("#subtotal-value");
  subtotalValue.textContent = subtotalRaw !== null
    ? `R$ ${parseFloat(subtotalRaw).toLocaleString("pt-BR", {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    })}`
    : "—";

  // Total
  const totalRaw = payload.total_price ?? null;

  const totalValue = document.querySelector("#total-value");
  totalValue.textContent = totalRaw !== null
    ? `R$ ${parseFloat(totalRaw).toLocaleString("pt-BR", {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    })}`
    : "—";

  // === Botões ===

  document.querySelector("#help-button").style.display = 'none';

  document.querySelector("#summary-next-step-title").textContent = "Orçamento disponível";
  document.querySelector("#summary-revise-title").textContent = "Orçamento em análise";

  document.querySelector("#summary-revise-info").textContent = "Próxima etapa";
  document.querySelector("#summary-request-info").textContent = "Você está aqui";

  const approve_button = document.querySelector("#approve-button");
  if (approve_button) {
    approve_button.style.display = "none";
  }
}


function renderProposalInfos(proposalRecords) {
  // Número da proposta
  const propostaValue = document.querySelector("#proposal-number-value");
  propostaValue.textContent = proposalRecords.id;

  // Emitida em
  const emitidaValue = document.querySelector("#issued-value");
  const emitidaDate = new Date(proposalRecords.proposalDate);
  emitidaValue.textContent = emitidaDate.toLocaleDateString("pt-BR", {
    day: "2-digit",
    month: "2-digit",
    year: "2-digit",
    timeZone: "UTC",
  });

  // Válida até
  const validaValue = document.querySelector("#validity-value");
  const validaDate = new Date(proposalRecords.validityPeriod);
  validaValue.textContent = validaDate.toLocaleDateString("pt-BR", {
    day: "2-digit",
    month: "2-digit",
    year: "2-digit",
    timeZone: "UTC",
  });

  // Realizada por

  const realizadaValue = document.querySelector("#created-by-value");
  if (!proposalRecords.contact) {
    realizadaValue.textContent = "Usuário não encontrado";
  } else {
    realizadaValue.textContent = proposalRecords.contact.name + " " + proposalRecords.contact.surname;
  }
}

function renderProposalInfosCreated(proposalRecords) {
  const payload = proposalRecords?.payload ?? {};

  document.querySelector("#informacoes-da-proposta-title").textContent = "Informações do orçamento";

  // Número da proposta
  document.querySelector("#proposal-number-label").textContent = "Nº Inicial do orçamento";

  const propostaValue = document.querySelector("#proposal-number-value");
  propostaValue.textContent = payload.id ?? "—";

  // Emitida em
  document.querySelector("#issued-label").textContent = "Data de Criação";
  const emitidaValue = document.querySelector("#issued-value");
  const emitidaRaw = payload.created_at ?? null;

  const emitidaDate = emitidaRaw ? new Date(emitidaRaw) : new Date();
  emitidaValue.textContent = emitidaDate.toLocaleDateString("pt-BR", {
    day: "2-digit",
    month: "2-digit",
    year: "2-digit",
    timeZone: "UTC",
  });

  document.querySelector("#validity-div").style.display = "none";

  // Criado por
  const customer = payload.customer ?? {};
  const firstName = customer.first_name ?? "";
  const lastName = customer.last_name ?? "";

  const realizadaValue = document.querySelector("#created-by-value");
  if (!firstName && !lastName) {
    realizadaValue.textContent = "Usuário não encontrado";
  } else {
    realizadaValue.textContent = `${firstName} ${lastName}`;
  }
}



function renderProposalOrderDetails(proposalRecords) {
  // Informações
  const ownerName = document.querySelector("#owner-name-value");
  const ownerEmail = document.querySelector("#owner-email-value");
  if (!proposalRecords.contact) {
    ownerName.textContent = "Usuário não encontrado";
    ownerEmail.textContent = "Email não encontrado";
  } else {
    ownerName.textContent = proposalRecords.contact.name + " " + proposalRecords.contact.surname;
    ownerEmail.innerHTML = proposalRecords?.contact?.email?.replace(/\./g, ".<wbr>");
  }

  // Endereços
  const deliveryAddress = document.querySelector("#delivery-address-value");
  const municipality =
    proposalRecords.freight.municipality != null
      ? proposalRecords.freight.municipality
      : "";
  const city =
    proposalRecords.freight.municipalityName != null
      ? proposalRecords.freight.municipalityName
      : "";

  if (
    municipality != null &&
    municipality != "" &&
    city != null &&
    city != ""
  ) {
    deliveryAddress.textContent = `${proposalRecords.freight.deliveryAddress}, ${municipality}/${city}`;
  } else {
    deliveryAddress.textContent = `${proposalRecords.freight.deliveryAddress}`;
  }

  // Forma de pagamento
  const paymentMethod = document.querySelector("#payment-method-value");
  paymentMethod.textContent = proposalRecords.payment.paymentConditionName;
}


function renderProposalPaymentMethod(proposalRecords) {
  // Nome da condição de pagamento
  const paymentCondition = document.querySelector("#payment-label");
  paymentCondition.textContent = proposalRecords.payment.paymentConditionName;

  document.querySelector('#details-total-label').textContent = proposalRecords.payment.installment ?? "";
}

function renderWhoBought(proposalRecords) {
  // Endereço
  const buyerAddress = document.querySelector("#address-value");

  const municipality = proposalRecords.freight.municipality != null ? proposalRecords.freight.municipality : "";
  const city = proposalRecords.freight.municipalityName != null ? proposalRecords.freight.municipalityName : "";

  if (
    municipality != null &&
    municipality != "" &&
    city != null &&
    city != ""
  ) {
    buyerAddress.textContent = `${proposalRecords.freight.deliveryAddress}, ${municipality}/${city}`;
  } else {
    buyerAddress.textContent = `${proposalRecords.freight.deliveryAddress}`;
  }
}

function renderBackButtom() {
  const backButton = document.querySelector(".back-button");
  if (!backButton) {
    console.error("❌ #back-button-container não encontrado no DOM.");
    return;
  }
  backButton.setAttribute("data-page", "/pages/orcamentos");

  document.querySelectorAll(".back-button").forEach((link) => {
    link.addEventListener("click", async (event) => {
      if (link.classList.contains("logout-link")) return;

      event.preventDefault();
      const pageUrl = link.getAttribute("data-page");
      setActiveLink(link);

      try {
        const response = await fetch(pageUrl);
        if (!response.ok) throw new Error("Erro ao carregar a página.");

        const html = await response.text();
        const parser = new DOMParser();
        const doc = parser.parseFromString(html, "text/html");
        const content = doc.querySelector("#page-account");

        const pageContent = document.getElementById("page-content");
        pageContent.innerHTML = content
          ? content.innerHTML
          : "<p>Conteúdo não encontrado.</p>";

        if (pageUrl === "/pages/orcamentos") {
          await loadProposalData();
          document.querySelectorAll(".sidebar .menu a").forEach((link) => {
            if (link.getAttribute("data-page") === "/pages/orcamentos") {
              link.classList.add("active");
            }
          });
        }
      } catch (error) {
        console.error(error);
        document.getElementById("page-content").innerHTML =
          "<p>Erro ao carregar o conteúdo.</p>";
      }
    });
  });
}

function renderDownloadProposalButton(trackingCode) {
  const downloadButton = document.querySelector("#download-proposal");
  if (!downloadButton) {
    console.error("❌ #download-proposal não encontrado no DOM.");
    return;
  }

  if (!trackingCode) {
    console.error("TrackingCode não encontrado.");
    return;
  }

  const shopDomain = window.shopDomainValue;

  let url = "";
  if (shopDomain === "shop.lightera.com") {
    url = `https://www3.furukawasolutions.com/cotacao_proposta?id=${trackingCode}`;
  } else {
    url = `https://furukawa--qa.sandbox.my.salesforce-sites.com/cotacao_proposta?id=${trackingCode}`;
  }

  downloadButton.addEventListener("click", (event) => {
    event.preventDefault();
    window.open(url, "_blank");
  });
}

function renderDownloadCsvButton(currentProposalRecords) {

  const downloadButton = document.querySelector("#download-csv");
  if (!downloadButton) {
    return;
  }

  downloadButton.addEventListener("click", (event) => {
    event.preventDefault();

    const products = currentProposalRecords.products;

    if (!products || products.length === 0) {
      downloadButton.classList.add("failed");

      if (!document.querySelector('.details-text-csv-failed')) {
        const p = document.createElement("p");
        p.textContent = "Nenhum produto disponível para download.";
        p.style.color = "red";
        p.classList.add("details-text-csv-failed");
        downloadButton.insertAdjacentElement("afterend", p);

      }
      return;
    }

    const idBudgetCsv = ['Orçamento', currentProposalRecords.id, '\n', '\n'];
    const displayNameCsv = ['Referência', currentProposalRecords.displayName, '\n', '\n'];

    const headers = [
      'Item',
      'Código',
      'Descrição',
      'Qtde.',
      'Unid.',
      'Preço Unitário',
      'Preço Total'
    ];

    const headerRow = headers.map(h => `"${h}"`).join(',');

    const dataRows = products.map((product, index) => {
      const rowData = [
        index + 1,
        product.productCode ?? '',
        product.productName ?? '',
        product.quantity ?? 0,
        product.unitOfMeasure ?? '',
        product.grossPrice ?? 0.0,
        product.grossTotal ?? 0.0
      ];

      return rowData.map(value => `"${value}"`).join(',');
    });

    const csvContent = idBudgetCsv + displayNameCsv + [headerRow, ...dataRows].join('\n');

    const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });

    const link = document.createElement("a");
    const url = URL.createObjectURL(blob);
    link.setAttribute("href", url);

    link.setAttribute("download", `proposta_${currentProposalRecords.id}.csv`);
    link.style.visibility = 'hidden';
    document.body.appendChild(link);

    link.click();
    document.body.removeChild(link);
  });
}

function formatShippingAddress(shipping) {
  if (!shipping || !shipping.address1) return "Endereço não disponível";

  let raw = shipping.address1.trim();

  // Remove prefixos conhecidos
  raw = raw.replace(/^[A-Z\s]+:\s*/i, "");

  // Separar rua + número
  let streetPart = raw.split(",")[0] ?? "";
  let numberPart = raw.split(",")[1]?.split("-")[0]?.trim() ?? "";
  let neighborhoodPart = raw.includes("-")
    ? raw.split("-")[1].trim()
    : "";

  // Ajustar pontuação no final da rua
  if (!streetPart.endsWith(".")) streetPart += ".";

  const city = shipping.city ?? "";
  const province = shipping.province_code ?? shipping.province ?? "";
  const zip = shipping.zip ?? "";
  const country = shipping.country ?? "";

  return `${streetPart}, ${numberPart}, ${neighborhoodPart} - ${city} - ${province}, ${zip}, ${country}`;
}


function renderProposalOrderDetailsCreated(proposalRecords) {
  const payload = proposalRecords?.payload ?? {};
  const customer = payload.customer ?? {};
  const shipping = payload.shipping_address ?? {};

  document.querySelector("#detalhes-do-pedido-title").textContent = "Detalhes do orçamento";

  // Nome do comprador
  const ownerName = document.querySelector("#owner-name-value");
  ownerName.textContent =
    `${customer.first_name ?? ""} ${customer.last_name ?? ""}`.trim() ||
    "Usuário não encontrado";

  // Email
  const ownerEmail = document.querySelector("#owner-email-value");
  ownerEmail.innerHTML = (payload.email ?? "Email não encontrado")
    .replace(/\./g, ".<wbr>");

  // Endereço formatado corretamente
  const deliveryAddress = document.querySelector("#delivery-address-value");
  deliveryAddress.textContent = formatShippingAddress(shipping);

  // Pagamento
  const payment = payload.metafields ?? {};
  const paymentMethod = document.querySelector("#payment-method-value");

  paymentMethod.textContent = payment.pix
    ? "PIX"
    : payment.rewards
      ? "REWARDS"
      : payment.creditCard
        ? "CARTÃO DE CRÉDITO"
        : payment.friendlyName ?? "—";

}



function renderProposalPaymentMethodCreated(proposalRecords) {
  const payload = proposalRecords?.payload ?? {};
  const payment = payload.metafields ?? {};

  const paymentCondition = document.querySelector("#payment-label");
  paymentCondition.textContent = payment.pix
    ? "PIX"
    : payment.rewards
      ? "REWARDS"
      : payment.creditCard
        ? "CARTÃO DE CRÉDITO"
        : payment.friendlyName ?? "—";

  document.querySelector('#details-total-label').textContent = payment.installment ?? "";
}

function renderWhoBoughtCreated(proposalRecords) {
  const payload = proposalRecords?.payload ?? {};
  const shipping = payload.shipping_address ?? {};

  const buyerAddress = document.querySelector("#address-value");
  buyerAddress.textContent = formatShippingAddress(shipping);
}

function renderDownloadProposalButtonCreated() {
  const downloadButton = document.querySelector("#acesse-sua-proposta");
  if (downloadButton) {
    downloadButton.style.display = "none";
  }
}

function renderProposalItemsCreated(lineItems) {
  const itemsBlockElement = document.querySelector("#itens-pedido-block");

  if (!itemsBlockElement) {
    console.error("[renderProposalItemsCreated] Erro ao recuperar o elemento de itens da proposta ");
    return;
  }

  try {
    itemsBlockElement.setAttribute("style", "display:flex");

    const itemsElement = document.querySelector('#itens-pedido-content');

    if (lineItems && lineItems.length > 0) {
      const listElement = document.createElement("ul");
      listElement.classList.add("proposal-items-list");

      for (const lineItem of lineItems) {
        const itemElement = document.createElement("li");

        const imageContainerElement = document.createElement("div");
        imageContainerElement.classList.add("proposal-item-image-container");
        const imageElement = document.createElement("img");
        imageContainerElement.appendChild(imageElement);
        imageElement.src = lineItem.image ? lineItem.image : "https://shop.lightera.com/cdn/shop/files/produto_sem_imagem_500px.jpg";

        const itemInfoElement = document.createElement("div");
        itemInfoElement.classList.add("proposal-item-info");

        const codeElement = document.createElement("div");
        codeElement.textContent = `Código: ${lineItem.variant_title}`;
        itemInfoElement.appendChild(codeElement);

        const titleElement = document.createElement("div");
        titleElement.classList.add("proposal-item-title");
        titleElement.textContent = lineItem.title;
        itemInfoElement.appendChild(titleElement);

        const quantity = lineItem.quantity;
        const quantityElement = document.createElement("div");
        quantityElement.classList.add("proposal-item-quantity");
        quantityElement.textContent = `${quantity} unidade${quantity > 0 ? 's' : ''}`;
        itemInfoElement.appendChild(quantityElement);

        itemElement.appendChild(imageContainerElement);
        itemElement.appendChild(itemInfoElement);

        listElement.appendChild(itemElement);
      }

      itemsElement.appendChild(listElement);
    } else {
      itemsElement.textContent = "Não há produtos no pedido";
    }
  } catch (error) {
    console.error("[renderProposalItemsCreated] Erro ao exibir itens da proposta. ");
  }
}

function renderDetailProposalCreated(proposalRecords) {
  currentProposalRecords = proposalRecords;
  currentTrackingCode = currentProposalRecords?.customProperties?.trackingCode || "";
  renderProposalOverviewCreated(proposalRecords);
  renderBackButtom();
  renderProposalInfosCreated(proposalRecords);
  renderProposalOrderDetailsCreated(proposalRecords);
  renderProposalPaymentMethodCreated(proposalRecords);
  renderWhoBoughtCreated(proposalRecords);
  renderDownloadProposalButtonCreated(currentTrackingCode);
  renderProposalItemsCreated(proposalRecords.payload.line_items);
}

function renderDetailProposal(proposalRecords) {
  currentProposalRecords = proposalRecords;
  currentTrackingCode = currentProposalRecords?.customProperties?.trackingCode || "";
  renderProposalOverview(proposalRecords);
  renderBackButtom();
  renderProposalInfos(proposalRecords);
  renderProposalOrderDetails(proposalRecords);
  renderProposalPaymentMethod(proposalRecords);
  renderWhoBought(proposalRecords);
  renderDownloadProposalButton(currentTrackingCode);
  renderDownloadCsvButton(currentProposalRecords);
}

async function sendHelpMessage(customerId, observation) {
  const accessToken = await login();
  const proposalId = currentProposalRecords.id;

  const response = await fetch(
    `${baseUrl}/shopify-order-connector/v1/shopify-order-connector/quotes/negotiation`,
    {
      method: "POST",
      headers: {
        Authorization: `Bearer ${accessToken}`,
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        id: proposalId,
        customerId: `gid://shopify/Customer/${customerId}`,
        observation: observation,
      }),
    }
  );

  if (!response.ok) {
    const errorDetails = await response.text();
    console.error(`Erro: ${errorDetails}`);
    throw new Error(`Erro ao buscar orçamentos: ${response.status}`);
  }

  return response;
}

function hasCableProducts() {
  if (
    !currentProposalRecords ||
    !currentProposalRecords.products ||
    currentProposalRecords.products.length === 0
  ) {
    throw new Error("Nenhum produto encontrado na proposta atual.");
  }

  return currentProposalRecords.products.some((product) =>
    product.productName.toLowerCase().includes("cabo")
  );
}

function applyPhoneMask(event) {
  let input = event.target;
  let value = input.value.replace(/\D/g, "");
  value = value.substring(0, 11);
  if (value.length > 10) {
    input.value = value.replace(/(\d{2})(\d{5})(\d{4})/, "($1) $2-$3");
  } else if (value.length > 6) {
    input.value = value.replace(/(\d{2})(\d{4})(\d{0,4})/, "($1) $2-$3");
  } else if (value.length > 2) {
    input.value = value.replace(/(\d{2})(\d*)/, "($1) $2");
  } else {
    input.value = value;
  }
}

async function approveProposal() {
  const paymentCondition = currentProposalRecords.payment.paymentCondition;
  const draftUrl = currentProposalRecords.customProperties.invoiceUrl;
  const poNumber = currentProposalRecords.customProperties.poNumber;
  let pixId;
  let cardId;

  showPopup("spinner", "");

  if (baseUrl === "https://ws.efurukawa.com/prd") {
    pixId = "535067";
    cardId = "541067";
  } else {
    pixId = "528067";
    cardId = "462067";
  }

  if (paymentCondition === pixId || paymentCondition === cardId) {
    if (draftUrl) {
      console.log("Redirecionando para o checkout do rascunho:", draftUrl);
      (window.location.href = draftUrl), "_blank";
    } else {
      console.error("URL do rascunho não encontrado.");
      showPopup(
        "Problemas ao aprovar orçamento",
        "Tivemos um problema ao redirecioná-lo para o checkout. Por favor, tente novamente mais tarde ou entre em contato com nosso suporte."
      );
    }
  } else {
    const modal = document.querySelector(".custom-modal");
    modal.classList.add("active");
    modal.innerHTML = `
        <div class="modal-content centralized">
          <div class="modal-header">
            <h2 class="modal-title">Observações para entrega?</h2>
            <span class="modal-text">Se você possui instruções especiais para entrega ou observações sobre seu pedido, utilize os campos abaixo:</span>
            </div>
            <div class="modal-inputs">
              <span class="modal-subtitle">Número do pedido de compra (Opcional)</span>
              <input id="quote-po-number" class="textarea" type="text" ${poNumber ? "disabled" : ""
      } placeholder="${poNumber ? poNumber : "Digite o número do pedido de compra"
      }" value="${poNumber || ""}">
              <span class="modal-subtitle">Observações para entrega</span>
              <textarea id="quote-observation" class="textarea" rows="4" placeholder="Digite sua mensagem aqui..."></textarea>
              ${true
        ? `
                <br/>
                <hr/>
                <span class="modal-atention">Caso seu pedido tenha bobinas</span>
                
                <span class="modal-subtitle">Possui estrutura própria para recebimento de cargas mais pesadas?</span>
                <span class="modal-text">Exemplo: Doca, empilhadeira ou munck próprios, plataforma, etc</span>
                <div class="modal-radio-div">
                  <div class="modal-radio-container">
                    <input type="radio" class="modal-radio" id="has-structure" name="has-structure" value="Sim">
                    <label for="has-structure">Sim</label>
                  </div>
                  <div class="modal-radio-container">
                    <input type="radio" class="modal-radio" id="hasn't-structure" name="has-structure" value="Não">
                    <label for="hasn't-structure">Não</label>
                  </div>
                </div>

                <span class="modal-subtitle">Informe um contato para recebimento</span>
                <div class="details-info">
                  <div class="modal-input-container">
                    <span class="modal-subtitle">Nome:</span>
                    <input id="quote-contact-name" class="textarea" type="text">
                  </div>
                  <div class="modal-input-container">
                    <span class="modal-subtitle">Telefone:</span>
                    <input id="quote-contact-number" class="textarea" type="numeric" oninput="applyPhoneMask(event)">
                  </div>
                </div>
              `
        : ``
      }
              <div class="error-div"></div>
            </div>
            <div style="display: flex; justify-content: space-evenly; gap: 10px;">
              <button class="custom-main-btn outlined" onclick="winQuote()">Sem Observação</button>
              <button class="custom-main-btn" onclick="winQuote()">Enviar</button>
            </div>
        </div>
      `;
  }
}

async function winQuote() {
  const accessToken = await login();
  const proposalId = currentProposalRecords._id;
  const observacaoCotacao = document.getElementById("quote-observation").value;
  const poNumber = document.getElementById("quote-po-number").value;
  const divErro = document.querySelector(".error-div");
  divErro.innerHTML = "";
  let estruturaDescarga;
  let contatoRecebimento;

  // if (hasCableProducts()) {
  const hasStructureBlock = document.querySelector(
    'input[name="has-structure"]:checked'
  )?.value;
  const contactName = document.getElementById("quote-contact-name").value;
  const contactPhone = document.getElementById("quote-contact-number").value;
  if (!hasStructureBlock) {
    divErro.innerHTML = `<span class="error-text">Por favor, selecione se possui estrutura própria.</span>`;
    return;
  }

  if (
    (!contactName || contactPhone.length < 14) &&
    hasStructureBlock === "Não"
  ) {
    divErro.innerHTML = `<span class="error-text">Por favor, preencha o nome e telefone do contato para recebimento.</span>`;
    document
      .getElementById("quote-contact-name")
      .classList.toggle("error", !contactName);
    document
      .getElementById("quote-contact-number")
      .classList.toggle("error", contactPhone.length < 14);
    return;
  }

  document.getElementById("quote-contact-name").classList.remove("error");
  document.getElementById("quote-contact-number").classList.remove("error");

  estruturaDescarga = hasStructureBlock === "Sim";
  contatoRecebimento = `${contactName} - ${contactPhone}`;
  // }
  showPopup("spinner", "");

  const response = await fetch(
    `${baseUrl}/shopify-order-connector/v1/shopify-order-connector/quotes/win`,
    {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${accessToken}`,
      },
      body: JSON.stringify({
        quoteId: proposalId,
        customerId: customerId,
        poNumber: poNumber,
        observacaoCotacao: observacaoCotacao,
        estruturaDescarga: estruturaDescarga,
        contatoRecebimento: contatoRecebimento,
      }),
    }
  );

  if (!response.ok) {
    const errorDetails = await response.text();
    console.error(`Erro: ${errorDetails}`);
    showPopup(
      "Problemas ao aprovar o orçamento",
      "Tivemos problemas ao aprovar seu orçamento. Por favor, tente novamente mais tarde ou entre em contato com nosso suporte."
    );
    throw new Error(`Erro ao finalizar compra: ${response.status}`);
  }

  showPopup(
    "Pedido fechado com sucesso",
    `
        <div class="modal-messages">
          <p class="modal-message">Logo você receberá mais informações sobre o andamento do seu Pedido.</p>
          
          <div class="modal-important">
            <p class="modal-message-title">Importante:</p>
            <ul class="modal-message-list">
              <li>Se seu orçamento utilizar Limite de Crédito, o pedido estará sujeito à análise de crédito antes da confirmação final.</li>
            </ul>
          </div>
        </div>
      `
  );
}

function showPopup(title, message) {
  const modal = document.querySelector(".custom-modal");
  modal.classList.add("active");

  if (title === "spinner" && message === "") {
    modal.innerHTML = `<div class="modal-content centralized"></div>`;
    showMyAccountSpinner(document.querySelector(".modal-content"));
    return;
  } else {
    let messageContent = "";
    if (typeof message === "string") {
      messageContent = `<span class="modal-subtitle">${message}</span>`;
    } else {
      messageContent = message;
    }

    modal.innerHTML = `
    <div class="modal-content centralized">
    <div class="modal-header">
    <h2 class="modal-title">${title}</h2>
    ${messageContent}
    </div>
    <button id="close-popup" class="custom-main-btn">Voltar a minha conta</button>
    </div>
    `;

    document.getElementById("close-popup").addEventListener("click", () => {
      closeModal();
      window.location.href = "/pages/minha-conta";
    });
  }
}

// let directionChangeOk = true;

// async function proposalSortDirection() {
//   if (directionChangeOk) {
//     directionChangeOk = false;
//     sortAscending = !sortAscending;
//     const sortButtons = document.querySelectorAll(".sort-button");
//     if (sortButtons) {
//       sortButtons.forEach((button) => {
//         button.classList.toggle("asc", sortAscending);
//       });
//     }
//     await searchProposals();
//     setTimeout(() => {
//       directionChangeOk = true;
//     }, 1000);
//   }
// }

async function searchProposals() {
  const filterValue = document.querySelector(".custom-search-input-proposal").value.toUpperCase();
  let proposalStatus;
  let filterBy = "proposalsIdsLike";
  let filterByDraft = "draftOrderIdLike";

  const sortDirection = sortAscending ? "asc" : "desc";

  const titleTabs = document.querySelectorAll(".orcamento-tab");
  titleTabs.forEach((tab) => {
    if (tab.classList.contains("active")) {
      switch (tab.textContent) {
        case "Em aberto":
          proposalStatus = "Aprovado";
          break;
        case "Finalizados":
          proposalStatus = "Fechado";
          break;
        case "Criados":
          proposalStatus = "Criados";
          break;
      }
    }
  });

  // await getProposalData(1, proposalStatus, filterBy, filterValue, sortDirection);
  if (proposalStatus == "Criados") {
    await getDraftOrders(1, proposalStatus, filterByDraft, filterValue);
  } else {
    await getProposalData(1, proposalStatus, filterBy, filterValue);
  }
}

function handleNoRecordsMessage(tabName) {
  const element = document.querySelector(`#tab-${tabName}`);

  element.innerHTML = `<div class='dados'><span>Não há orçamentos ${tabName}</span></div>`;
}
